import { render, staticRenderFns } from "./SafeDigAchievements.vue?vue&type=template&id=3c2c9a2e&scoped=true"
import script from "./SafeDigAchievements.vue?vue&type=script&lang=js"
export * from "./SafeDigAchievements.vue?vue&type=script&lang=js"
import style0 from "./SafeDigAchievements.vue?vue&type=style&index=0&id=3c2c9a2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c2c9a2e",
  null
  
)

export default component.exports